/**
 * 画像検索用VOクラス
 *
 * @export KYMW0B00InputModel
 * @class KYMW0B00InputModel
 */
export class KYMW0B00InputModel {

  // 処理区分
  public processDiv = String('0');

  // C2PF検索項目表示フラグ
  public c2pfSearchVisibleFlg = String('0');
}
